import React from "react";

function BlogPage() {
  return <div>blogpage</div>;
}

export default BlogPage;
